module.exports = __webpack_public_path__ + "static/img/2.bfab078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-3/2.png
// module id = s26A
// module chunks = 0